import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StandardsList = ({ className = '' }) => {
  const [standards, setStandards] = useState([]);
  useEffect(() => {
    axios.get(`${API}/directory/standards`).then(r => setStandards(r.data.standards)).catch(() => {});
  }, []);
  return (
    <ol className={`list-decimal pl-5 space-y-2 text-sm text-gray-700 ${className}`} data-testid="standards-list">
      {standards.map((s, i) => <li key={i}>{s}</li>)}
    </ol>
  );
};
